export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('INDEX.form_label_shipmentNo') || '发运单编号',
    field: 'shipmentNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_customer_name') || '客户名称',
    field: 'custName',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_endcustomer_name') || '终端客户名称',
    field: 'endCustName',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_shipmentType') || '出运方式',
    field: 'v_shipmentType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_orderScmCode') || '名义工厂',
    field: 'orderScmName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.form_label_bookingDate') || '订舱日期',
  //   field: 'bookingDate',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.form_label_plannedETD') || '计划发运日期',
    field: 'plannedETD',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_cargoReadyDay') || '货好时间',
    field: 'deliveryDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.form_deliveryDate') || '产装日期',
  //   field: 'deliveryDate',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_label_ActualETD') || '实际发运日期',
  //   field: 'actualETD',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_label_eta') || '到港日期',
  //   field: 'eta',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_isSingleNo') || '是否多单号',
  //   field: 'v_isSingleNo',
  //   width: 100,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_bookingNo') || '订舱单号',
  //   field: 'bookingNo',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_label_customsNo') || '关单号',
  //   field: 'customsNo',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_label_vessel') || '船名',
  //   field: 'vessel',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_label_voyage') || '航次',
  //   field: 'voyage',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.form_label_totalGoodsQty') || '产品总数量',
    field: 'totalGoodsQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.form_label_totalBoxQty') || '总箱数',
  //   field: 'totalBoxQty',
  //   width: 100,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.form_label_totalGrossWeight') || '总毛重',
    field: 'v_totalGrossWeight',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalNetWeight') || '总净重',
    field: 'v_totalNetWeight',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalBoxVolume') || '总体积',
    field: 'v_totalBoxVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.form_label_totalBookingVolume') || '订舱总体积',
  //   field: 'v_totalBookingVolume',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.form_label_shipmentAmount') || '成本总价',
    field: 'v_totalPriceAmount',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_shipmentSalePrice') || '销售总价',
    field: 'v_totalSalePriceAmount',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.form_contractNo') || '合同号',
  //   field: 'contractNo',
  //   width: 150,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_docCutOffDate') || '截单日期',
  //   field: 'docCutOffDate',
  //   width: 120,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_closingDate') || '截港日期',
  //   field: 'closingDate',
  //   width: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_bookingStaff') || '制单人',
  //   field: 'bookingStaffName',
  //   width: 100,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.table_label_quotation_method') || '报价方式',
  //   field: 'v_quotedMethod',
  //   width: 100,
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_shipper') || '发货人',
  //   field: 'shipperCustomerName',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_consignee') || '收货人',
  //   field: 'consigneeCustomerName',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_notifier') || '通知人',
  //   field: 'notifierCustomerName',
  //   width: 150,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_bookingScm') || '订舱货代',
  //   field: 'bookingScmName',
  //   width: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_customsBrokerScmCode') || '报关货代',
  //   field: 'customsBrokerScmName',
  //   width: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.form_transitScm') || '运输公司',
  //   field: 'transitScmName',
  //   width: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.form_label_shipmentStatus') || '单据状态',
    field: 'shipmentStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('INDEX.table_label_submit_by') || '提交人',
  //   field: 'submitByName',
  //   align: 'center',
  //   width: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.table_label_submit_time') || '提交时间',
  //   field: 'submitTime',
  //   align: 'center',
  //   width: 170,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.table_label_reviewer_by_name') || '审核人',
  //   field: 'reviewByName',
  //   align: 'center',
  //   width: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('INDEX.table_label_reviewer_by_time') || '审核时间',
  //   field: 'reviewTime',
  //   align: 'center',
  //   width: 170,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
]
